import { useState } from 'react';
import { SelectOption } from '../../searchableSelect/searchableSelectTypes';
import { useTransaction } from '../../../context/TransactionContext';
import { useFetchMatterPhase } from '../../../hooks/useFetchMatterPhase';
import { ITransaction } from '../../../interface/transaction';

/** The props `SearchableSelect` needs to pick a matter phase, from the same list the picker screen uses. */
export const useMatterPhaseSelect = () => {
  const { transaction, updateTransaction } = useTransaction();
  const [searchValue, setSearchValue] = useState('');
  const {
    data: matterPhases,
    isLoading,
    isFetchingNextPage,
    hasNextPage,
    fetchNextPage,
  } = useFetchMatterPhase({
    sortBy: ['name:ASC'],
    pageSize: 50,
    search: searchValue,
    matterId: transaction?.matter?.id,
  });

  const options: SelectOption[] = matterPhases.map(({ id, name }) => ({
    value: id,
    label: name,
  }));
  const value: SelectOption | null = transaction?.matterPhase?.id
    ? { value: transaction.matterPhase.id, label: transaction.matterPhase.name }
    : null;

  const onChange = (option: SelectOption) => {
    const matterPhase = matterPhases.find(({ id }) => id === option.value);
    if (!matterPhase) return;
    updateTransaction({
      ...transaction,
      matterPhase,
      matterPhaseId: matterPhase.id,
      shouldLoadServerPrice: false,
    } as ITransaction);
  };

  return {
    options,
    value,
    onChange,
    onSearch: setSearchValue,
    onLoadMore: fetchNextPage,
    hasMore: Boolean(hasNextPage),
    loading: isLoading,
    loadingMore: isFetchingNextPage,
  };
};
